<ng-container *ngIf="!selectedTaskId && !taskCreationMode">
    <div class="task-panel-header">
        <gsp-button [type]="ButtonType.Icon" [iconClass]="'icon_line_close_24 i24'" (click)="closePanel()"></gsp-button>
        <h2 *ngIf="isAddToTaskMode">{{ 'TC.ToDos.AddToTask' | translate }}</h2>
        <ng-container *ngIf="!isAddToTaskMode">
            <h2>{{ 'TC.Common.Tasks' | translate }}</h2>
            <div class="task-panel-menu-bar">
                <gsp-button
                    [ngClass]="{ disabled: isSearchButtonDisabled() }"
                    class="search-button"
                    [type]="ButtonType.Icon"
                    [iconClass]="'icon_line_search_24 i24'"
                    title="{{ 'TC.Common.Search' | translate }}"
                    [disabled]="isSearchButtonDisabled()"
                    (action)="toggleTaskSearch()"
                ></gsp-button>
                <gsp-button
                    [type]="ButtonType.Icon"
                    [iconClass]="'icon_solid_sort_24 i24'"
                    title="{{ 'sort' | translate }}"
                    (click)="taskSortMenu.openContextMenu($event)"
                ></gsp-button>
                <sort-menu
                    #taskSortMenu
                    [menuItems]="sortMenuItems"
                    [selectedSortOption]="taskSortMode"
                    [currentSortDirection]="taskSortDirection"
                    (sortChange)="sortTaskList($event)"
                    [disabled]="loading"
                ></sort-menu>
                <gsp-button
                    [type]="ButtonType.Icon"
                    [iconClass]="'icon_solid_task_add_green_32 i24'"
                    title="{{ 'ToDos.CreateTask.Tooltip' | translate }}"
                    (action)="taskCreationMode = TaskCreationMode.NEW"
                ></gsp-button>
            </div>
        </ng-container>
    </div>

    <gsp-notification *ngIf="isTasksFiltered && !loading" [type]="NotificationType.Info">
        <div class="messages" [innerHTML]="'TC.ToDosTask.TasksAreBeingFiltered' | translate"></div>
    </gsp-notification>
    <gsp-notification *ngIf="isNonTemplatedFeaturesExcluded && !loading" [type]="NotificationType.Warning">
        <div>
            {{ 'TCS.Todo.Todo.NontemplatedFeaturesExcluded' | translate }}
        </div>
    </gsp-notification>

    <ul class="task-tabs" *ngIf="!isAddToTaskMode && (activeTasks.length || closedTasks.length || isTaskSearchActive)">
        <li
            [ngClass]="{ 'active-tab': currentTab === TaskPanelTabs.ACTIVE }"
            (click)="setCurrentTab(TaskPanelTabs.ACTIVE)"
        >
            <h3 id="tasks-active" translate="TC.Common.Active"></h3>
        </li>
        <li
            [ngClass]="{ 'active-tab': currentTab === TaskPanelTabs.CLOSED }"
            (click)="setCurrentTab(TaskPanelTabs.CLOSED)"
        >
            <h3 id="tasks-closed" translate="TC.Common.Complete"></h3>
        </li>
    </ul>

    <div class="task-search" *ngIf="isTaskSearchActive">
        <div class="task-search-bar">
            <input
                type="text"
                [formControl]="taskSearchControl"
                placeholder="{{
                    currentTab === TaskPanelTabs.ACTIVE
                        ? ('TC.ToDosTask.Search.ActiveTasks' | translate)
                        : ('TC.ToDosTask.Search.CompleteTasks' | translate)
                }}"
                class="gsp-form-input disabled-txt"
            />
        </div>
    </div>

    <div class="scroll-wrapper">
        <custom-scroll [triggerScrollToPosition]="currentScrollPosition" [triggerScrollToTop]="scrollToTop">
            <ul class="list-content" *ngIf="currentTab === TaskPanelTabs.ACTIVE">
                <li class="no-hover" *ngIf="loading">
                    <loading class="loading-align-center"></loading>
                </li>
                <ng-container *ngIf="!loading">
                    <div *ngIf="!activeTasks.length" class="info-message-rectangle">
                        {{ 'TC.ToDos.NoTasksAvailable' | translate }}
                    </div>
                    <div class="panel-notification" *ngIf="activeTasks.length > 99">
                        <gsp-notification [type]="NotificationType.Info">
                            {{ 'TC.Todo.Search.LimitNotification' | translate }}
                        </gsp-notification>
                    </div>
                    <div class="panel-notification" *ngIf="isTaskVisibilityRestricted">
                        <gsp-notification [type]="NotificationType.Info">
                            {{ 'MapViewer.Tasks.Visibility.Notification' | translate }}
                        </gsp-notification>
                    </div>

                    <li
                        (click)="setSelectedTask(task)"
                        *ngFor="let task of activeTasks"
                        [ngClass]="{ selected: task.selected, 'task-loading': task.loading }"
                        class="task-item"
                    >
                        <div class="task-title">
                            <div class="heading text-overflow" title="{{ task.title }}">{{ task.title }}</div>
                            <div
                                *ngIf="!isAddToTaskMode"
                                class="task-view"
                                (click)="toggleVisibleTask(task, $event)"
                                [ngClass]="{ hide_layer: !task.visible }"
                            >
                                <i
                                    class="i24"
                                    [ngClass]="{
                                        icon_line_visibility_show: task.visible,
                                        icon_line_visibility_hide: !task.visible
                                    }"
                                ></i>
                            </div>
                            <gsp-checkbox
                                *ngIf="isAddToTaskMode"
                                [value]="taskToCheckboxMap.get(task)"
                                (change)="setTaskToCheckboxMap(task, $event)"
                                [id]="'addToTaskCheckbox'"
                            >
                            </gsp-checkbox>
                        </div>
                        <div class="description" title>{{ task.description }}</div>
                        <div class="task-status-container">
                            <div *ngIf="task.totalTaskedForms" class="task-status-container-item">
                                <donut
                                    [thickness]="0.32"
                                    [size]="18"
                                    [alertColor]="'#5E9331'"
                                    [warningColor]="'#5E9331'"
                                    [dangerColor]="'#5E9331'"
                                    [index]="TaskPanelTabs.ACTIVE + task.id"
                                    [percent]="task.percentageComplete"
                                ></donut>
                                <div class="task-count">
                                    <span>
                                        {{ task.totalCollectedFeatures }}/{{ task.totalTaskedForms }}
                                        {{ 'TC.Common.TaskFormsUpdated' | translate }}
                                    </span>
                                </div>
                            </div>
                            <div class="task-status-container-item newly-collected-count">
                                <i class="icon_solid_clipboard_24 mixin-icon-24"></i>
                                <span>
                                    {{
                                        'TC.Common.NewFormsCollectedWithParams'
                                            | translate: { newFormsCount: task.newFeatures }
                                    }}
                                </span>
                            </div>
                        </div>
                    </li>
                </ng-container>
            </ul>

            <ul class="list-content" *ngIf="currentTab === TaskPanelTabs.CLOSED">
                <li class="no-hover" *ngIf="loading">
                    <loading class="loading-align-center"></loading>
                </li>
                <ng-container *ngIf="!loading">
                    <div *ngIf="!closedTasks.length" class="info-message-rectangle">
                        {{ 'TC.ToDos.NoTasksAvailable' | translate }}
                    </div>
                    <div class="panel-notification" *ngIf="closedTasks.length > 99">
                        <gsp-notification [type]="NotificationType.Info">
                            {{ 'TC.Todo.Search.LimitNotification' | translate }}
                        </gsp-notification>
                    </div>
                    <div class="panel-notification" *ngIf="isTaskVisibilityRestricted">
                        <gsp-notification [type]="NotificationType.Info">
                            {{ 'MapViewer.Tasks.Visibility.Notification' | translate }}
                        </gsp-notification>
                    </div>

                    <li
                        (click)="setSelectedTask(task)"
                        *ngFor="let task of closedTasks"
                        [ngClass]="{ selected: task.selected, 'task-loading': task.loading }"
                        class="task-item"
                    >
                        <div class="task-title">
                            <div class="heading" title="{{ task.title }}">{{ task.title }}</div>
                            <div
                                class="task-view"
                                (click)="toggleVisibleTask(task, $event)"
                                [ngClass]="{ hide_layer: !task.visible }"
                            >
                                <i
                                    class="i24"
                                    [ngClass]="{
                                        icon_line_visibility_show: task.visible,
                                        icon_line_visibility_hide: !task.visible
                                    }"
                                ></i>
                            </div>
                        </div>
                        <div class="description" title>{{ task.description }}</div>
                        <div class="task-status-container">
                            <div class="task-status-container-item">
                                <donut
                                    [thickness]="0.32"
                                    [size]="18"
                                    [alertColor]="'#5E9331'"
                                    [warningColor]="'#5E9331'"
                                    [dangerColor]="'#5E9331'"
                                    [index]="TaskPanelTabs.CLOSED + task.id"
                                    [percent]="task.percentageComplete"
                                ></donut>
                                <div class="task-count">
                                    <span>
                                        {{ task.totalCollectedFeatures }}/{{ task.totalTaskedForms }}
                                        {{ 'TC.Common.TaskFormsUpdated' | translate }}
                                    </span>
                                </div>
                            </div>
                            <div class="task-status-container-item newly-collected-count">
                                <i class="icon_solid_clipboard_24 mixin-icon-24"></i>
                                <span>
                                    {{
                                        'TC.Common.NewFormsCollectedWithParams'
                                            | translate: { newFormsCount: task.newFeatures }
                                    }}
                                </span>
                            </div>
                        </div>
                    </li>
                </ng-container>
            </ul>
        </custom-scroll>
    </div>
    <footer *ngIf="isAddToTaskMode && !loading">
        <gsp-button
            [type]="ButtonType.Transparent"
            (action)="closePanel()"
            text="{{ 'cancel' | translate }}"
            id="cancel-add-to-task"
        ></gsp-button>
        <gsp-button
            [disabled]="!isSaveEnabled"
            [type]="ButtonType.Primary"
            (action)="saveAddToTask()"
            text="{{ 'TCW.Common.Confirm' | translate }}"
            id="confirm-add-to-task"
        ></gsp-button>
    </footer>
</ng-container>

<ng-container *ngIf="taskCreationMode || selectedTaskId">
    <task-detail-panel
        [taskId]="selectedTaskId"
        (setTaskPanelTab)="setCurrentTab($event, true)"
        class="task-list map-menus"
    ></task-detail-panel>
</ng-container>
